<template>
  <ValidationProvider name="Name" slim vid="name" rules="required">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="audience_name"> Name </BaseFormLabel>
        <BaseFormInput id="audience_name" v-model="name" :disabled="disabled" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: Boolean,
  },
  computed: {
    name: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
